export default __webpack_public_path__ + "static/media/3039.44475a31.jpg";